import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useLanguage } from "../i18n/LanguageContext";
import TodayPlanCard from "../components/TodayPlanCard";
import HadithOfDayBadge from "../components/HadithOfDayBadge";
import QuranTree from "../components/QuranTree";
import ClassReminderBanner from "../components/ClassReminderBanner";
import FamilyMessages from "../components/FamilyMessages";
import CareCard from "../components/CareCard";

export default function Dashboard() {
  const { user } = useAuth();
  const { tx, t } = useLanguage();
  const [legacy, setLegacy] = useState(null);
  const [encouragements, setEncouragements] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/legacy").then((r) => setLegacy(r.data)).catch(() => {}),
      api.get("/encouragements").then((r) => setEncouragements(r.data || [])).catch(() => {}),
    ]);
  }, []);

  return (
    <div className="space-y-8" data-testid="dashboard-page">
      <ClassReminderBanner />
      <CareCard />
      {encouragements.map((e, i) => (
        <div key={i} className="rounded-xl border-l-4 border-gold-500 bg-gold-500/10 bg-sand-200/70 p-4 flex items-center gap-3" data-testid="encouragement-banner">
          <span className="text-xl">🤲</span>
          <div className="text-sm text-foreground/85">
            <strong className="text-forest-700">{e.from_name}</strong> {t("dashboard.sentYou")} “{tx(e.message)}”
          </div>
        </div>
      ))}
      <header>
        <div className="text-xs uppercase tracking-[0.22em] text-gold-600 font-semibold">{t("dashboard.greeting")}</div>
        <h1 className="mt-1 font-display font-semibold text-4xl text-forest-700">{user?.name?.split(" ")[0] || t("dashboard.friend")}</h1>
        <p className="mt-2 text-foreground/70">{t("dashboard.tagline")}</p>
      </header>

      <HadithOfDayBadge />

      {/* Today's Plan — smart daily planner */}
      <TodayPlanCard />

      <FamilyMessages />

      {/* Quran Tree — daily-motivation progress visualization; moved to the
          bottom of the home page. */}
      {legacy?.me && (
        <section className="hifz-card" data-testid="dash-quran-tree">
          <div className="flex items-end justify-between mb-2">
            <h2 className="font-display font-semibold text-xl text-forest-700">{t("dashboard.quranTree")}</h2>
            <Link to="/app/legacy" className="text-sm text-forest-700 hover:underline" data-testid="dash-legacy-link">
              {t("dashboard.fullLegacy")}
            </Link>
          </div>
          <QuranTree ayahs={legacy.me.ayahs} pages={legacy.me.pages} />
        </section>
      )}
    </div>
  );
}
